import React from '@root/vendor/react';

const InterfaceActionsContext = React.createContext({});

export default InterfaceActionsContext;
